import React from 'react';
import Paper from '@material-ui/core/Paper';
import { useStyles } from './RoundPlate.styles';
var RoundPlate = function (_a) {
    var roundName = _a.roundName;
    var classes = useStyles();
    return React.createElement(Paper, { className: classes.container }, roundName);
};
export { RoundPlate };
